:host {
  display: block;
  --primary: var(--sl-primary, #004ace);
  --secondary: var(--sl-secondary, #5f5f5f);
  --default: var(--sl-default, #202121);
  --danger: var(--sl-danger, #cc0e00);
  --warning: var(--sl-warning, #f6a600);
  --success: var(--sl-success, #04802d);

  &,
  & > * {
    box-sizing: border-box;
  }
}

.sportsline-button {
  text-decoration: none;
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid var(--default);
  color: var(--default);
  letter-spacing: -0.25px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sportsline-button--primary {
  color: var(--primary);
  border: 1px solid var(--primary);
}

.sportsline-button--secondary {
  color: var(--secondary);
  border: 1px solid var(--secondary);
}

.sportsline-button--success {
  color: var(--success);
  border: 1px solid var(--success);
}

.sportsline-button--danger {
  color: var(--danger);
  border: 1px solid var(--danger);
}

.sportsline-button--warning {
  color: var(--warning);
  border: 1px solid var(--warning);
}

.sportsline-button--small {
  padding: 0.5rem;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
}

.sportsline-button--medium {
  padding: 0.5rem;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  @media screen and (min-width: 768px) {
    padding: 0.75rem;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25;
  }
}
